import {createSlice, createAsyncThunk} from "@reduxjs/toolkit"
import ItemService from "../../../services/commonService";


export const fetchReportsList = createAsyncThunk("getReportsListData", async(value) => {
    const {name} = value
    const res = await ItemService.getTransactionListData(value);
    res.name=name;
    return res
})

export const addReportsRecord = createAsyncThunk("addReportsRecord", async(value) => {
    let res 
    if(!value.edit){
        res = await ItemService.addTransactionData(value);
    } else {
        res = await ItemService.updateTransactionData(value);
    }  
    return res
})

export const fetchReportsListById = createAsyncThunk("getReportsListDataById", async(param) => {
    const {page} = param
    const res = await ItemService.getTransactionListDataById(param);
    res.name=page;
    return res
})

export const downloadReportsData = createAsyncThunk("downloadReportsData", async(value,searchValue) => {
    const {name} = value
    const res = await ItemService.downloadReportsData(value);
    res.name=name;
    return res
})

const getReportsListData = createSlice({
    name:"commonReportsList",
    initialState: {
        isLoading:false,
        page:{},
        isError:false,
    },
    reducers: {
       
    },
    extraReducers:(builder) => {
        builder.addCase(fetchReportsList.pending,(state,action) => {
            state.isLoading=true;
        })
        builder.addCase(fetchReportsList.fulfilled, (state,{payload}) => {
            state.isLoading=false;
            state.page[payload.name]=payload
            state.isError=false
        })
        builder.addCase(addReportsRecord.pending,(state,action) => {
            state.isLoading=true;
        })
        builder.addCase(addReportsRecord.fulfilled, (state,{payload}) => {
            state.isLoading=false;
            state.isError=false;
        })
    }
})

export default getReportsListData.reducer;